import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.dataset.catalogReady = "true"
  }

  disconnect() {
    delete this.element.dataset.catalogReady
  }

  pageLoaded() {
    const soldOutSeparators = this.element.querySelectorAll(".info-sold-out")
    Array.from(soldOutSeparators).slice(1).forEach(element => element.remove())
    window.dispatchEvent(new Event("resize"))
  }
}
